const DAY_MS = 86_400_000

/** Whole calendar days from `now` to `end` in the viewer's timezone. 0 means it ends today. */
export function calendarDaysUntil(end: Date, now: Date): number {
  const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  return Math.round((startOfDay(end) - startOfDay(now)) / DAY_MS)
}

/** Compact trial date for chrome and captions, e.g. "Nov 2". */
export function formatShortDate(date: Date): string {
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

/** Full trial date for consent and legal copy, e.g. "November 2, 2026". */
export function formatLongDate(date: Date): string {
  return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })
}
